module.exports = __webpack_public_path__ + "static/media/ICBT 3a2.d8d6435f.jpg";